import { useEffect, useState } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Categories } from "@/components/site/Categories";
import { Vendors } from "@/components/site/Vendors";
import { Packages } from "@/components/site/Packages";
import { Reviews } from "@/components/site/Reviews";
import { Enquiry } from "@/components/site/Enquiry";
import { VendorRegister } from "@/components/site/VendorRegister";
import { Founders } from "@/components/site/Founders";
import { Footer } from "@/components/site/Footer";
import { WhatsAppFab } from "@/components/site/WhatsAppFab";

function App() {
  const [preset, setPreset] = useState("");

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); window.__lenis = null; };
  }, []);

  return (
    <div className="bg-cream text-ink font-body min-h-screen">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Categories onPick={setPreset} />
        <Vendors />
        <Packages onPick={setPreset} />
        <Reviews />
        <Enquiry preset={preset} />
        <VendorRegister />
        <Founders />
      </main>
      <Footer />
      <WhatsAppFab />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
